import { render } from "./ChartOfAccountList.vue?vue&type=template&id=5b9fe104"
import script from "./ChartOfAccountList.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__